import { Tabs } from "@mwi/ui";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const MwiAdminLayout = () => {
  const location = useLocation();

  if (location.pathname === "/admin/mwi") {
    return <Navigate to="/admin/mwi/practices" replace />;
  }

  return (
    <div>
      <h1 className="text-5xl font-bold">MWI Admin</h1>

      <Tabs className="my-12">
        <Tabs.Item
          to="/admin/mwi/practices"
          title="Vet practices"
          isActive={location.pathname === "/admin/mwi/practices"}
        />
        <Tabs.Item
          to="/admin/mwi/users"
          title="User management"
          isActive={location.pathname === "/admin/mwi/users"}
        />
      </Tabs>

      <Outlet />
    </div>
  );
};

export default MwiAdminLayout;
